function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 21",
    width: 24,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32 21.22H0V-.22h32v21.44z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.9h32V-.22H0V6.9z",
    style: {
      fill: "rgb(14, 159, 74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21.22h32V14.1H0v7.12z",
    style: {
      fill: "rgb(5, 6, 8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97 21.22H0V-.22h7.97v21.44z",
    style: {
      fill: "rgb(208, 32, 44)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUae);
export default __webpack_public_path__ + "static/media/uae.f39cbc4ecdecb7fa533a7c318c82a2cb.svg";
export { ForwardRef as ReactComponent };